import { __extends } from "tslib";
import { exposeGetters } from '@skbkontur/react-ui/lib/theming/ThemeHelpers';
var AddonsTheme = /** @class */ (function (_super) {
    __extends(AddonsTheme, _super);
    function AddonsTheme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AddonsTheme, "addonsTopBarTextColor", {
        //#region TopBar
        get: function () {
            return this.textColorDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarBg", {
        get: function () {
            return this.bgDefault;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarItemHeight", {
        get: function () {
            return this.addonsTopBarHeight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarItemLineHeight", {
        get: function () {
            return this.addonsTopBarItemHeight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarAvatarItemHeight", {
        get: function () {
            return "calc(" + this.addonsUserAvatarSize + " + 2 * " + this.addonsTopBarAvatarItemOutline + ")";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarAvatarItemPaddingY", {
        get: function () {
            return this.addonsTopBarAvatarItemOutline;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarAvatarItemPaddingX", {
        get: function () {
            return this.addonsTopBarAvatarItemOutline;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarAvatarItemMarginY", {
        get: function () {
            return "-" + this.addonsTopBarAvatarItemOutline;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsTopBarAvatarItemMarginX", {
        get: function () {
            return "calc(-" + this.addonsTopBarAvatarItemOutline + " + " + this.addonsTopBarAvatarItemGap + ")";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsLogoBorderColorFocus", {
        get: function () {
            return this.borderColorFocus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsLogoDividerBg", {
        get: function () {
            return this.addonsTopBarDividerBg;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsLogoButtonHeight", {
        get: function () {
            return this.addonsLogoButtonSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddonsTheme, "addonsLogoButtonWidth", {
        get: function () {
            return this.addonsLogoButtonSize;
        },
        enumerable: false,
        configurable: true
    });
    AddonsTheme.addonsTopBarShadow = '';
    AddonsTheme.addonsTopBarDividerBg = '#dfdfdf';
    AddonsTheme.addonsTopBarDividerHeight = '24px';
    AddonsTheme.addonsTopBarDividerMarginX = '8px';
    AddonsTheme.addonsTopBarHeight = '32px';
    AddonsTheme.addonsTopBarItemPaddingY = '0px';
    AddonsTheme.addonsTopBarItemPaddingX = '8px';
    AddonsTheme.addonsTopBarItemMarginY = '0px';
    AddonsTheme.addonsTopBarItemMarginX = '0px';
    AddonsTheme.addonsTopBarAvatarItemOutline = '4px';
    AddonsTheme.addonsTopBarAvatarItemGap = '8px';
    AddonsTheme.addonsTopBarPaddingX = '6px';
    AddonsTheme.addonsTopBarPaddingY = '16px';
    AddonsTheme.addonsTopBarMarginBottom = '0';
    AddonsTheme.addonsTopBarItemIconGap = '4px';
    AddonsTheme.addonsTopBarIconColor = '#222';
    AddonsTheme.addonsTopBarItemBorderRadius = '4px';
    AddonsTheme.addonsTopBarItemActionBackground = 'rgba(0, 0, 0, 0.05)';
    AddonsTheme.addonsTopBarOrganizationsArrowWidth = '24px';
    AddonsTheme.addonsTopBarMenuSeparatorMarginX = '12px';
    AddonsTheme.addonsTopBarMenuSeparatorMarginY = '4px';
    AddonsTheme.addonsTopBarMenuSeparatorColor = 'rgba(0, 0, 0, 0.05)';
    AddonsTheme.addonsTopBarMenuItemHoverBg = 'rgba(0, 0, 0, 0.05)';
    AddonsTheme.addonsTopBarMenuItemHoverColor = '#222';
    AddonsTheme.addonsTopBarMenuItemCommentColorHover = '#3C3C3C';
    AddonsTheme.addonsTopBarMenuItemPaddingX = '12px';
    //#endregion
    //#region Logotype
    AddonsTheme.addonsLogoColor = '#000';
    AddonsTheme.addonsLogoHoverColor = '#000';
    AddonsTheme.addonsLogoDividerHeight = '24px';
    AddonsTheme.addonsLogoDividerWidth = '0px';
    AddonsTheme.addonsLogoDividerMarginX = '0';
    // public static addonsLogoWidgetPaddingX = '0';
    AddonsTheme.addonsLogoWidgetPaddingX = '0px';
    AddonsTheme.addonsLogoButtonSize = '24px';
    AddonsTheme.addonsLogoButtonMarginLeft = '4px';
    AddonsTheme.addonsLogoButtonActionBorderRadius = '50%';
    AddonsTheme.addonsLogoButtonActionBackground = 'none';
    AddonsTheme.addonsLogoButtonColor = '#aaa';
    AddonsTheme.addonsLogoButtonActionColor = '#222';
    //#endregion
    //#region UserAvatar
    AddonsTheme.addonsUserAvatarSize = '32px';
    AddonsTheme.addonsUserAvatarBorderRadius = '100%';
    AddonsTheme.addonsUserAvatarBorderColor = '#222222';
    AddonsTheme.addonsUserAvatarBackground = 'transparent';
    AddonsTheme.addonsUserAvatarHoverBackground = '#222';
    AddonsTheme.addonsUserAvatarActiveBackground = '#222';
    AddonsTheme.addonsUserAvatarColor = '#222';
    AddonsTheme.addonsUserAvatarHoverColor = '#fff';
    AddonsTheme.addonsUserAvatarActiveColor = '#fff';
    return AddonsTheme;
}(/** @class */ (function () {
    function class_1() {
    }
    return class_1;
}())));
export { AddonsTheme };
export var REACT_UI_ADDONS_THEME_KEY = '__IS_REACT_UI_ADDONS_THEME__';
export var markAsAddonsTheme = function (theme) {
    var _a;
    return Object.create(theme, (_a = {},
        _a[REACT_UI_ADDONS_THEME_KEY] = {
            value: true,
            writable: false,
            enumerable: false,
            configurable: false,
        },
        _a));
};
export var isAddonsTheme = function (theme) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    //@ts-ignore
    return theme[REACT_UI_ADDONS_THEME_KEY] === true;
};
export var AddonsThemeInternal = exposeGetters(AddonsTheme);
